import { useTheme } from "@/presentation/contexts/ThemeContext";
import { AssetIcon } from "@/presentation/components/common/icon/AssetIcon";
import { qaAttr, type QaAttrOptions } from "@/presentation/utils/qaAttr";

interface AddMediaButtonProps {
  backgroundColor?: string;
  iconBackgroundColor?: string;
  buttonSize?: number;
  iconSize?: number;
  /** If omitted, the icon container is rendered as a circle (radius = buttonSize). */
  borderRadius?: number;
  onTap: () => void;
  /** Optional `data-qa-*` set for the clickable root `<div>` so the qa-tester can locate it. */
  qa?: QaAttrOptions;
}

export const AddMediaButton = ({
  backgroundColor,
  iconBackgroundColor,
  buttonSize = 48,
  iconSize = 24,
  borderRadius,
  onTap,
  qa,
}: AddMediaButtonProps) => {
  const { theme } = useTheme();

  const bgColor = backgroundColor ?? theme.background;
  const iconBgColor = iconBackgroundColor ?? theme.secondary;

  return (
    <div
      {...(qa ? qaAttr(qa) : {})}
      onClick={onTap}
      className="cursor-pointer flex items-center justify-center"
      style={{
        backgroundColor: bgColor,
        maxHeight: buttonSize,
      }}
    >
      <div
        className="flex items-center justify-center"
        style={{
          width: buttonSize,
          height: buttonSize,
          backgroundColor: iconBgColor,
          borderRadius: borderRadius ?? buttonSize,
        }}
      >
        <AssetIcon
          path="/assets/images/add.png"
          width={iconSize}
          height={iconSize}
          color={theme.exclusive}
        />
      </div>
    </div>
  );
};
